import { DateTime } from "luxon";
import { BaseQueryParams } from "../../../../Components/Core/BasePage/BaseQueryParams";

export class QueryParams extends BaseQueryParams
{
    public date?: DateTime;
    public floor?: string;
    public workType?: string;
    public spaceType?: string;
    public capacity?: number;
    public hasCatering?: boolean;
    public hasEquipment?: boolean;

    public serialise(propertyName: keyof QueryParams, propertyValue: any): string | null
    {
        switch (propertyName)
        {
            case 'date':
                return this.serialiseDate(propertyValue);
            case 'capacity':
                return this.serialiseNumber(propertyValue);
            case 'hasCatering':
            case 'hasEquipment':
                return this.serialiseBoolean(propertyValue);
            default:
                return super.serialise(propertyName, propertyValue);
        }
    }

    public deserialise(propertyName: keyof QueryParams, queryValue: string | null): any
    {
        switch (propertyName)
        {
            case 'date':
                return this.deserialiseDate(queryValue);
            case 'capacity':
                return this.deserialiseNumber(queryValue);
            case 'hasCatering':
            case 'hasEquipment':
                return this.deserialiseBoolean(queryValue);
            default:
                return super.deserialise(propertyName, queryValue);
        }
    }
}
